import { PlanLimitConfigs, BillingCycleConfig } from "../common.ts";

export const JIRA_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const JIRA_DEFAULT_UNIT_COUNT = 300;

export const JIRA_MIN_ENTERPRISE_USER_COUNT = 801;

export const jiraOfferingSkus = {
    free: "jira-software-free",
    standard: "jira-software-standard",
    premium: "jira-software-premium",
    enterprise: "jira-software-enterprise-sku"
} as const;

export const jiraOfferingSkusArray = Object.values(jiraOfferingSkus);

export const jiraPlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Free",
        offeringSku: jiraOfferingSkus.free,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Standard",
        offeringSku: jiraOfferingSkus.standard,
        recommendationLimit: 10,
        signupLimit: 50000
    },
    {
        planName: "Premium",
        offeringSku: jiraOfferingSkus.premium,
        recommendationLimit: 250,
        signupLimit: 50000
    },
    {
        planName: "Enterprise",
        offeringSku: jiraOfferingSkus.enterprise,
        recommendationLimit: 5000,
        signupLimit: 50000
    }
];

export const jiraBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
